<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Ocupantes - {{siniestro}}</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <mat-tab-group #ocupantes (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="true" mat-align-tabs="center"
    color="primary">
    @for (opcion of catTabsOcupantes ; track opcion) {
      <mat-tab [label]="opcion">
        <ng-template mat-tab-label>
          {{opcion.nombre}}
        </ng-template>
        <div class="contenedor-panel">
          @switch (opcion.id) {
            @case (1) {
              <app-crear-actualizar-ocupantes-asegurado
                [datosAsegurado]="datosLesionados.Asegurados" (eventosOcupantes)="consultarLesionadosGeneral(this.siniestro)">
              </app-crear-actualizar-ocupantes-asegurado>
            }
            @case (2) {
              <app-crear-actualizar-ocupante-tercero [datosTercero]="datosLesionados.Terceros"
                (eventosOcupantes)="consultarLesionadosGeneral(this.siniestro)">
              </app-crear-actualizar-ocupante-tercero>
            }
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>